import PERIOD_END_DATA_OPTIONS from '@/types/period-end-data-options';
import moment from 'moment';

export enum DATE_KEYS {
  SENT_AT = 'sentAt',
  UPDATED_AT = 'updatedAt',
}

export const getMaxEndDate = (monthEndDataOption?: PERIOD_END_DATA_OPTIONS, defaultOverride?: Date | undefined) => {
  switch (monthEndDataOption) {
    case PERIOD_END_DATA_OPTIONS.RECENT_MONTH_END:
      return moment().subtract(1, 'months').endOf('month').startOf('day').toDate();
    case PERIOD_END_DATA_OPTIONS.PREVIOUS_MONTH_END:
      return moment().subtract(2, 'months').endOf('month').startOf('day').toDate();
    case PERIOD_END_DATA_OPTIONS.RECENT_QUARTER_END:
      return moment().subtract(1, 'quarters').endOf('quarter').startOf('day').toDate();
    case PERIOD_END_DATA_OPTIONS.PREVIOUS_QUARTER_END:
      return moment().subtract(2, 'quarters').endOf('quarter').startOf('day').toDate();
    default:
      return defaultOverride || moment().startOf('day').toDate();
  }
};

export const sortByDateKey = (a: any, b: any, key = DATE_KEYS.UPDATED_AT): number => {
  const aDate = a[key] ? new Date(a[key]).getTime() : 0;
  const bDate = b[key] ? new Date(b[key]).getTime() : 0;
  return bDate - aDate;
};

export const convertDateToString = (date: Date | null): string | null => {
  if (!date) {
    return null;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const convertStringToDate = (dateString: string | null): Date | null => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return null;

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
};
